import appLogoImg from './app-logo.png'
import rewardBgImg from './reward-bg.png'
import vipImg from './vip.png'
import coinsImg from './coins.png'

import beansImg from './beans.png'
import beansOffImg from './beans-off.png'

import coinImg from './coin.png'
import coinOffImg from './coin-off.png'

import chatPassImg from './chat-pass.png'
import chatPassOffImg from './chat-pass-off.png'

import superChatPassImg from './super-chat-pass.png'
import superChatPassOffImg from './super-chat-pass-off.png'

import videoPassImg from './video-pass.png'
import videoPassOffImg from './video-pass-off.png'

import callPassImg from './call-pass.png'
import callPassOffImg from './call-pass-off.png'

import couponImg from './coupon.png'
import couponOffImg from './coupon-off.png'

export default {
  'app-logo': appLogoImg,
  'reward-bg': rewardBgImg,
  vip: vipImg,
  coins: coinsImg,

  beans: beansImg,
  'beans-off': beansOffImg,

  coin: coinImg,
  'coin-off': coinOffImg,

  'chat-pass': chatPassImg,
  'chat-pass-off': chatPassOffImg,

  'super-chat-pass': superChatPassImg,
  'super-chat-pass-off': superChatPassOffImg,

  'video-pass': videoPassImg,
  'video-pass-off': videoPassOffImg,

  'call-pass': callPassImg,
  'call-pass-off': callPassOffImg,

  coupon: couponImg,
  'coupon-off': couponOffImg,
}
